import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import CaseLawDocumentsByDateReportPresenter, {
  ICaseLawDocumentsByDateReportPresenter
} from "../presenter/CaseLawDocumentsByDateReportPresenter";

export default class ShowCaseLawDocumentsByDateReportInteractor {
  private application: Application;
  private output?: ICaseLawDocumentsByDateReportPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
  }

  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getOrganisations()]);
  }

  execute() {
    this.output = CaseLawDocumentsByDateReportPresenter({
      application: this.application,
      initialState: {
        selectedCategoryId: NaN,
        organisations: [],
        indexCategories: [],
        dateIncluded: undefined,
        data: []
      }
    });
    this.getReferenceLists().then(([organisations]) => {
      this.output?.loadReferenceValues(organisations);
    });
    return this.output;
  }
}
